import { Component, effect, input, model } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgScrollbar } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';
import { SvgIconName } from '../svg-icon/svg-icon-name';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-dropdown',
  imports: [
    NgScrollbar,
    TranslateModule,
    BsDropdownModule,
    SharedModule,
    SvgIconComponent,
  ],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {

  public renderIndBody = input<boolean>(false);
  public itemIcon = input<SvgIconName>();
  public isDropup = input<boolean>(false);
  public label = input.required<string>();
  public items = input.required<any[]>();
  public selectedItem = model<any>();

  constructor() {
    effect(() => {
      const items = this.items();
      if (items && !items.includes(this.selectedItem())) {
        this.selectedItem.set(undefined);
      }
    });
  }

  public selectItem(item: any) {
    this.selectedItem.set(item);
  }
}
